import React from 'react';
import Immutable from 'immutable';
import { v4 as uuidv4 } from 'uuid';
import cn from 'classnames';
import { InView } from 'react-intersection-observer';

import { libraryShape } from '@bibliocommons/bc-prop-types';
import Heading from '@bibliocommons/heading';

import ListCardAdapter from 'app/components/shared/ListCardAdapter';
import { listsMappedProps } from 'app/shapes/browse/rows';

import './Lists.scss';
import PropTypes from 'prop-types';

const Lists = ({
  additionalAnalyticsPayload,
  library,
  lists,
  title,
  trackListCreatorClick,
  trackListImageClick,
  trackListImpression,
  trackListTitleClick,
  userByListId
}) => {
  if (!lists.length) {
    return null;
  }

  const renderItem = (list, index, stacked = false) => {
    const listId = list.id;
    const creatorUser = Immutable.fromJS(userByListId[listId]);
    const itemPosition = index + 1;
    const className = cn('list-item', { 'list-item--stacked': stacked }, stacked ? 'col-sm-12' : 'col-sm-3');
    const impressionIdSuffix = uuidv4();
    const uiContainerTitle = title;

    const handleVisibility = visibleListId => {
      return isVisible => {
        if (isVisible) {
          trackListImpression({
            ...additionalAnalyticsPayload,
            impressionId: `${visibleListId}-${impressionIdSuffix}`,
            itemPosition,
            list,
            uiContainerTitle
          });
        }
      };
    };

    return (
      <li key={listId} className={className}>
        <InView threshold={1} triggerOnce onChange={handleVisibility(listId)}>
          <ListCardAdapter
            creator={creatorUser}
            handleListTitleClick={() =>
              trackListTitleClick({
                ...additionalAnalyticsPayload,
                impressionId: `${listId}-${impressionIdSuffix}`,
                itemPosition,
                list,
                uiContainerTitle
              })}
            handleListImageClick={() =>
              trackListImageClick({
                ...additionalAnalyticsPayload,
                impressionId: `${listId}-${impressionIdSuffix}`,
                itemPosition,
                list,
                uiContainerTitle
              })}
            horizontal={stacked}
            library={library}
            list={Immutable.fromJS(list)}
            smallCreatorLink
            smallHeading
            titleTag="div"
            trackCreatorClick={({ linkText: creatorName }) => {
              trackListCreatorClick({
                ...additionalAnalyticsPayload,
                creatorName,
                list,
                itemPosition,
                uiContainerTitle
              });
            }}
          />
        </InView>
      </li>
    );
  };

  return (
    <div className="cp-browse-lists">
      <Heading className="heading" tagName="h2" size="moderate" variant>
        {title}
      </Heading>
      <ul className="row list-cards-row list-cards-row--desktop">
        {lists.map((list, index) => renderItem(list, index))}
      </ul>
      <ul className="row list-cards-row list-cards-row--mobile">
        {lists.map((list, index) => renderItem(list, index, true))}
      </ul>
    </div>
  );
};

Lists.defaultProps = {
  additionalAnalyticsPayload: {}
};

Lists.propTypes = {
  ...listsMappedProps,
  additionalAnalyticsPayload: PropTypes.object,
  library: libraryShape.isRequired,
  trackListCreatorClick: PropTypes.func.isRequired,
  trackListImageClick: PropTypes.func.isRequired,
  trackListImpression: PropTypes.func.isRequired,
  trackListTitleClick: PropTypes.func.isRequired
};

export default Lists;
